export enum ACTION_TYPE {
  ADD = "add",
  EDIT = "edit",
  DELETE = "delete",
}

export type ActionType = `${ACTION_TYPE}`;
